import { cx } from "../../lib/cx.js";
import { Icon } from "../Icon/Icon.js";
/* empty css               */
import { isValidElement } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/EmptyState/EmptyState.tsx
/**
* The zero state of a list, table or search: an optional icon, a title (a heading), a
* description of the next step, and actions. Native attributes go on the wrapper.
*/
function EmptyState({ title, description, icon, actions, size = "md", headingLevel = 3, className, ...rest }) {
	const Heading = `h${headingLevel}`;
	return /* @__PURE__ */ jsxs("div", {
		className: cx("ds-empty", `ds-empty--${size}`, className),
		...rest,
		children: [
			icon != null && /* @__PURE__ */ jsx("div", {
				className: "ds-empty__icon",
				"aria-hidden": "true",
				children: isValidElement(icon) ? icon : /* @__PURE__ */ jsx(Icon, { name: icon })
			}),
			/* @__PURE__ */ jsx(Heading, {
				className: "ds-empty__title",
				children: title
			}),
			description != null && /* @__PURE__ */ jsx("p", {
				className: "ds-empty__description",
				children: description
			}),
			actions != null && /* @__PURE__ */ jsx("div", {
				className: "ds-empty__actions",
				children: actions
			})
		]
	});
}
//#endregion
export { EmptyState };

//# sourceMappingURL=EmptyState.js.map